import GoogleMapReact from 'google-map-react';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, PopupFooter } from '@gem/ui-kit';

import { MapMarker } from 'APP/components/MapMarker/MapMarker';
import { GOOGLE_MAP_KEY } from 'APP/constants';

import { CenterPinButton } from './CenterPinButton/CenterPinButton';
import { MapControl } from './MapControl/MapControl';
import { ISelectLocationParams, useSelectLocationPopup } from './SelectLocationPopup.presenter';
import styles from './SelectLocationPopup.styles.m.css';

type ISelectLocationProps = ISelectLocationParams;

export const SelectLocationPopup: FC<ICommonPopupsProps<ISelectLocationProps>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useSelectLocationPopup(props);
    useClosePopupOnNavigation(props.popupInstance);

    if (!presenter.isShowPopup) {
      return null;
    }

    return (
      <Popup
        title={t('location_map_title')}
        isOpened
        onClose={presenter.onClose}
      >
        <div className={styles.mapContainer}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
            onClick={presenter.setCoordinates}
            onGoogleApiLoaded={presenter.setMaps}
            yesIWantToUseGoogleMapApiInternals
            defaultCenter={
              presenter.defaultLatitude !== null && presenter.defaultLongitude !== null
                ? {
                    lat: presenter.defaultLatitude,
                    lng: presenter.defaultLongitude,
                  }
                : undefined
            }
            defaultZoom={presenter.defaultZoom}
          >
            <MapMarker
              lat={presenter.latitude}
              lng={presenter.longitude}
            />
            <MapControl
              map={presenter.map}
              controlPosition={presenter.controlPosition}
            >
              <CenterPinButton centerPin={presenter.centerPin} />
            </MapControl>
          </GoogleMapReact>
        </div>

        <PopupFooter>
          <Button
            onClick={presenter.onSubmit}
            theme="primary"
          >
            {presenter.isSheduledGroup ? t('common_schedule') : t('send')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  }
);
